import { render } from "./AdminInfo.vue?vue&type=template&id=35d8134e&scoped=true"
import script from "./AdminInfo.vue?vue&type=script&lang=js"
export * from "./AdminInfo.vue?vue&type=script&lang=js"

import "./AdminInfo.vue?vue&type=style&index=0&id=35d8134e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-35d8134e"

export default script